<template>
    <div class="container page">
        <p>Password URL to fetch the password: </p>

        <div class="input-group input-group-lg bottom-margin">
            <span class="input-group-addon glyphicon glyphicon-lock"></span>
            <textarea id="secret-url" class="form-control" readonly v-model="secretUrl"></textarea>
        </div>

        <div class="input-group input-group-lg top-margin">
            <span class="input-group-addon glyphicon glyphicon-info-sign"></span>
            <textarea class="form-control" rows="3" v-model="notice"></textarea>
        </div>

        <p class="btn-container">
            <router-link to="/"><a class="btn btn-primary btn-lg" role="button">Back</a></router-link>
        </p>
    </div>
</template>

<script>
    export default {
        data (){
            return {
                secretUrl: '',
                hours: null,
                days: null,
                views: null,
            }
        },
        computed: {
            notice: function () {
                let ttl = '';
                
                if (this.days > 0 || this.hours > 0) {
                    ttl += 'ist nur ';
                    
                     if (this.days > 0 && this.days > 1) {
                        ttl += this.days + ' Tage ';
                    } else if (this.days > 0) {
                        ttl += this.days + ' Tag ';
                    }

                    if (this.days > 0 && this.hours > 0) {
                        ttl += ' und ';
                    }

                    if (this.hours > 0 && this.hours > 1) {
                        ttl += this.hours + ' Stunden ';
                    } else if (this.hours > 0) {
                        ttl += this.hours + ' Stunde ';
                    }

                    ttl += 'gültig und'
                }

                return `Hinweis: Der Link ${ttl} kann maximal ${this.views}x aufgerufen werden. Bitte das Passwort innerhalb dieses Zeitraums an einen sicheren Ort kopieren.`;
            }
        },
        mounted () {
            this.$emit('error', '');

            let secretKey = this.$route.params.secretKey;
            this.hours = this.$route.params.hours;
            this.days = this.$route.params.days;
            this.views = this.$route.params.views;

            this.secretUrl = window.location.protocol
                + '//'
                + window.location.host
                + window.location.pathname
                + '#/show-password/'
                + secretKey;

            window.focusInput("secret-url");
        }
    }
</script>
